import { forwardRef } from "react";

const FileUpload = forwardRef(({ handleFileChange }, ref) => {
  const handleChange = (e) => {
    handleFileChange(e);
    e.target.value = null;
  };
  return (
    <input
      type="file"
      id="custom-input"
      accept="image/png,image/jpeg,image/jpg"
      onChange={handleChange}
      ref={ref}
      style={{ display: "none" }}
    />
  );
});

export default FileUpload;
